import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import classnames from "classnames"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail:[{}],
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ],
            dochead:{},
            pegawai_pelantikan:[],
            pelantik:{},
            rohaniawan:{},
            saksi:[],
            penandatangan:{},
            random:0 ,
            activeTab: '1',
            dataForm:{},
            docPelantikan:{},
            docSaksi:{},
            invPegawai:{},
            invRohaniawan:{},
            docSPMT:{},
            IurlDocPelantikan:'',
            IurlDocEditPelantikan:'',
            IurlDocSaksi:'',
            IurlDocEditSaksi:'',
            IurlInvPegawai:'',
            IurlInvEditPegawai:'',
            IurlinvRohaniawan:'',
            IurlDocEditRohaniawan:'',
            IurlDocSPMT:'',
            IurlDocEditSPMT:'',
        }
    }
     toggle=(tab)=> {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            })
        }
    }
    generateDocMenghadiriPelantikan=(doctype)=> {
        this.setState({
            // dataForm: {
            //     docheaduuid : this.state.dochead.invitation_document_uuid,
            //     doctype : doctype
            // },
            loading: true
        })
        this.detailBloc.fetchGenerateDocument({uuid: this.state.dochead.invitation_document_uuid})
    }
    generateDocPelantikanSaksi=(doctype)=> {
        this.setState({
            loading: true
        })
        this.detailBloc.fetchGenerateUndanganSaksi({uuid: this.state.dochead.invitation_document_uuid})
        // alert('aaaaaaaaaaaaaa')
    }
    generateInvPelantikanPegawai=(doctype)=> {
        this.setState({
            loading: true
        })
        this.detailBloc.fetchGenerateInvPegawai({uuid: this.state.dochead.invitation_document_uuid,type: doctype})
        // alert('aaaaaaaaaaaaaa')
    }
    generateInvRohaniawan=(doctype)=> {
        this.setState({
            loading: true
        })
        this.detailBloc.fetchGenerateInvRohaniawan({uuid: this.state.dochead.invitation_document_uuid})
        // alert('aaaaaaaaaaaaaa')
    }
    generateDocPelantikanSPMT=(doctype)=> {
        this.setState({
            loading: true
        })
        this.detailBloc.fetchGenerateDocumentSPMT({uuid: this.state.dochead.invitation_document_uuid,type: doctype})
        // alert('aaaaaaaaaaaaaa')
    }
    handleOnDodraftingMenghadiriPelantikan = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditPelantikan,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    handleOnDodraftingSaksi = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditSaksi,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    handleOnDodraftingPegawai = () => {     
        const myWindowDoc = window.open(this.state.IurlInvEditPegawai,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    handleOnDodraftingRohaniawan = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditRohaniawan,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    handleOnDodraftingSPMT = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditSPMT,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                if(this.state.confirmAction == 1){
                    window.location.href = `/kepegawaian/undangan_pelantikan.html?update&uuid=${this.state.dochead.invitation_document_uuid}`;
                }else{
                    this.inactiveData()
                    // alert('aaaa')
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.detailBloc.fetchInactive({ uuid: this.state.dochead.invitation_document_uuid })
    }
    
    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response.dochead.invitation_document_type_name)
                        this.setState({
                            detail: response,
                            dochead: response.dochead,
                            pegawai_pelantikan: response.pegawai_pelantikan,
                            pelantik: response.pelantik,
                            rohaniawan: response.rohaniawan,
                            saksi: response.saksi,
                            penandatangan:response.penandatangan
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(window.location.search);
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid')})
        
            this.detailBloc.generateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokUndanganSaksi({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailInvPegawai({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailInvRohaniawan({uuid: queryParams.get('uuid'),type: 4 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })

            this.detailBloc.generateUndanganSaksiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokUndanganSaksi({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailInvPegawai({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailInvRohaniawan({uuid: queryParams.get('uuid'),type: 4 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })
            this.detailBloc.generatePegawaiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokUndanganSaksi({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailInvPegawai({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailInvRohaniawan({uuid: queryParams.get('uuid'),type: 4 })
                        // this.detailBloc.fetchDetailDokSPMT({uuid: queryParams.get('uuid'),type: 5 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })
            this.detailBloc.generateRohaniawanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokUndanganSaksi({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailInvPegawai({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailInvRohaniawan({uuid: queryParams.get('uuid'),type: 4 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })
            this.detailBloc.generateSPMTChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokUndanganSaksi({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailInvPegawai({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailInvRohaniawan({uuid: queryParams.get('uuid'),type: 4 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })
                    
                    this.detailBloc.docMenghadiriPelantikanChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    console.log(result.data.status)
                                    // console.log(response.document_file_path)
                                    this.setState({
                                        docPelantikan: response.detail,
                                        IurlDocPelantikan : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditPelantikan : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })

                    this.detailBloc.docSaksiChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    console.log(response)
                                    this.setState({
                                        docSaksi: response,
                                        IurlDocSaksi : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditSaksi : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                    console.log(this.state.IurlDocSaksi+' ini link pakta')
                                    console.log(this.state.docSaksi)
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailDokUndanganSaksi({uuid: queryParams.get('uuid'),type: 2 })

                    this.detailBloc.invPegawaiChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    // console.log(response.dochead.invitation_document_type_name)
                                    this.setState({
                                        invPegawai: response,
                                        IurlInvPegawai : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlInvEditPegawai : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailInvPegawai({uuid: queryParams.get('uuid'),type: 3 })

                    this.detailBloc.invRohaniawanChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    this.setState({
                                        invRohaniawan: response,
                                        IurlinvRohaniawan : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditRohaniawan : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                    console.log(this.state.invRohaniawan)
                                    console.log('ini spmj')
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailInvRohaniawan({uuid: queryParams.get('uuid'),type: 4 })

                    this.detailBloc.docSPMTChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    // console.log(response.dochead.invitation_document_type_name)
                                    this.setState({
                                        docSPMT: response,
                                        IurlDocSPMT : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditSPMT : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                    console.log(this.state.docSPMT)
                                    console.log('ini spmt')
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailDokSPMT({uuid: queryParams.get('uuid'),type: 5 })

                    console.log(this.state.docPelantikan)

                    this.detailBloc.inactiveChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                this.setState({
                                    loading: false,
                                    success: true,
                                    loadingTable: true
                                }, function () {
                                    // this.setTokenAPI()
                                    // this.props.handleInactiveSuccess()
                                    window.location.href = '/kepegawaian/undangan_pelantikan.html';
                                });
                                break
                            case apiResponse.ERROR:
                                this.setState({
                                    loading: false,
                                    failed: true,
                                });
                                break
                            default:
                                break
                        }
                    })
    }
    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["name"] = data.level_name;
          newObj["level"] = data.level_no;
      
          return newObj;
        });
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Data Undangan Pelantikan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Detail Data Undangan
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <Col md="5">
                                            
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nomor Surat
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{(this.state.dochead.invitation_document_number != null) ? this.state.dochead.invitation_document_number : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tanggal Surat
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{(this.state.dochead.invitation_document_invitation_date != null) ? moment(this.state.dochead.invitation_document_invitation_date).format('DD/MM/YYYY') : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tanggal Pelantikan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{(this.state.dochead.invitation_document_date != null) ? moment(this.state.dochead.invitation_document_date).format('DD/MM/YYYY') : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Lokasi
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.invitation_document_location !== "" ? this.state.dochead.invitation_document_location : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tempat Pelaksanaan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.invitation_document_place !== "" ? this.state.dochead.invitation_document_place : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Waktu Mulai
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.invitation_document_time_start !== "" ? this.state.dochead.invitation_document_time_start : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Waktu Selesai
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.invitation_document_time_end !== "" ? this.state.dochead.invitation_document_time_end : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Pakaian
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.invitation_document_clothes !== "" ? this.state.dochead.invitation_document_clothes : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                        
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Pegawai
                                                </label>
                                                <Col md="9">
                                                
                                                    {
                                                        this.state.pegawai_pelantikan.map((data, index) => {
                                                            return (
                                                                <>
                                                                    {(index+1)} . {data.employee_full_name} <br />
                                                                </>
                                                            )    
                                                        })
                                                    }
                                                    
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Saksi
                                                </label>
                                                <Col md="9">
                                                    
                                                    {
                                                        this.state.saksi.map((data, index) => {
                                                            return (
                                                                <>
                                                                    {(index+1)} . {data.employee_full_name} <br />     
                                                                </>
                                                            )    
                                                        })
                                                    }
                                                    
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Penandatangan
                                                </label>
                                                <Col md="9">
                                                    
                                                    {
                                                        this.state.penandatangan ?
                                                            <>{this.state.penandatangan.employee_full_name !== "" ? this.state.penandatangan.employee_full_name : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                    
                                                </Col>
                                            </Row>
                                            
                                            <Row className="mb-3">
                                                <Col md="9">
                                                        <Button color="success"
                                                        onClick={() => {
                                                            this.setState({confirmtext:"Apakah anda yakin akan mengubah form data, Undangan pelantikan yang sudah digenerate akan terhapus?"})
                                                            this.setState({confirm:true})
                                                            this.setState({confirmAction:1})
                                                            
                                                            
                                                        }}
                                                        style={{
                                                            padding: '2px 5px'
                                                        }}> Ubah Form</Button>
                                                    
                                                </Col>
                                                <Col md="3">
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <Col md="9">
                                                    <Link to="/kepegawaian/undangan_pelantikan.html" className="btn btn-danger waves-effect">
                                                        <i className="uil-arrow-left"></i> Kembali
                                                    </Link>
                                                    &nbsp;
                                                    <Button 
                                                        className="btn btn-warning" 
                                                        id={"delete-" + this.state.dochead.invitation_document_id}
                                                        onClick={() => {
                                                            this.setState({confirmtext:"Apakah anda yakin akan Menghapus Data Undangan pelantikan ini?"})
                                                            this.setState({
                                                                confirm: true,
                                                                confirmAction : 2
                                                            })
                                                        }}>
                                                            Batalkan Undangan Pelantikan
                                                    </Button>
                                                </Col>
                                                <Col md="3">
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md="9">
                                                </Col>
                                                <Col md="3">
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md="7" style={{marginTop: '-16px'}}>
                                            
                                            <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: this.state.activeTab === "1",
                                                    })}
                                                    onClick={() => {
                                                        this.toggle("1")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">Undangan Menghadiri Pelantikan</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                    active: this.state.activeTab === "2",
                                                        })}
                                                    onClick={() => {
                                                        this.toggle("2")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                    <span className="d-none d-sm-block">Undangan Saksi Pelantikan</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: this.state.activeTab === "3",
                                                    })}
                                                    onClick={() => {
                                                        this.toggle("3")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">Undangan Pelantikan</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: this.state.activeTab === "4",
                                                    })}
                                                    onClick={() => {
                                                        this.toggle("4")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">Permohonan Rohaniawan</span>
                                                </NavLink>
                                            </NavItem>
                                            
                                        </Nav>
                                        <TabContent activeTab={this.state.activeTab} className="p-3 text-muted">
                                            <TabPane tabId="1">
                                                <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.docPelantikan)?
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.handleOnDodraftingMenghadiriPelantikan()
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Ubah Draft</Button>
                                                            :
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.generateDocMenghadiriPelantikan(1)
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Genarate Surat Undangan Menghadiri Pelantikan</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.docPelantikan)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlDocPelantikan} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                            <TabPane tabId="2">
                                            <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.docSaksi.detail)?
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.handleOnDodraftingSaksi()
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Ubah Draft</Button>
                                                            :
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.generateDocPelantikanSaksi(2)
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Genarate Undangan Saksi Pelatikan</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.docSaksi)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlDocSaksi} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                            <TabPane tabId="3">
                                            <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.invPegawai.detail)?
                                                        <Button color="success"
                                                        onClick={() => {
                                                            this.handleOnDodraftingPegawai()
                                                        }}
                                                        style={{
                                                            padding: '2px 5px'
                                                        }}> Ubah Draft</Button>
                                                        :
                                                        <Button color="success"
                                                        onClick={() => {
                                                            this.generateInvPelantikanPegawai(3)
                                                        }}
                                                        style={{
                                                            padding: '2px 5px'
                                                        }}> Genarate Dokumen Undangan Pengambilan Sumpah Pegawai</Button>
                                                        
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.invPegawai.detail)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlInvPegawai} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                            <TabPane tabId="4">
                                            <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.invRohaniawan.detail!=null)?
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.handleOnDodraftingRohaniawan()
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Ubah Draft</Button>
                                                            :
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.generateInvRohaniawan(4)
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Genarate Surat Permohonan Bantuan Rohaniawan</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.invRohaniawan.detail!=null)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlinvRohaniawan} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                            <TabPane tabId="5">
                                            <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.docSPMT.detail)?
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.handleOnDodraftingSPMT()
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Ubah Draft</Button>
                                                            :
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.generateDocPelantikanSPMT(5)
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Genarate Dokumen SPMT</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.docSPMT)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlDocSPMT} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                        </TabContent>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={this.state.confirmtext}

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Document berhasil Digenerate"

                    failedTitle="Gagal!"
                    failedInfo="Dokumen gagal Digenerate"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);